import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/shadcn/ui/table';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@radix-ui/react-collapsible';
import InnerTable from './InnerTable';
import { ChevronDownIcon, ContactRound, EditIcon, Power, PowerOff, Trash2Icon, User } from 'lucide-react';
import Constants from '@/constants';
import { Badge } from '../shadcn/ui/badge';
import ContactFormDialog from '@/pages/clients/client_components/ContactForm';
import DeleteDialog from '@/pages/clients/client_components/DeleteClientDialog';
import { useClientContext } from '@/context/ClientContext';
import CustomInputMask from '@/utils/customInputMask';
import { useClients } from '@/hook/useClients';
import { ClientContact, CreateClientContact, UpdateClientContact } from '@/entities/clientContact';
import { UpdateClientStatusDto } from '@/entities/clients';

interface Contact{
  idContato: number;
  nomeContato: string;
  celular: string;
  clientId: number;
  fixo: string;
  email: string;
  funcao: string;
}

interface ContactFormData{
  id: number,
  name: string,
  phone: string,
  clientId: number,
  email: string;
  cellPhone: string,
  function: string
}

interface ClientFormData {
  id: number;
  nomefantasia: string;
  responsible: string;
  razao: string;
  ramo: string;
  status: string;
  cpfOrCnpj: string;
  //contato
  contatos: Contact[] | [];
  //endereco
  cep: string;
  rua: string;
  cidade: string;
  uf: string;
  bairro: string;
  numero: string;
}

type TableViewProps = {
  data: ClientFormData[];
  onClientStatusUpdate: (index: number, id:number, status:string) => void;
}

const TableView: React.FC<TableViewProps> = ({ data, onClientStatusUpdate}) => {
  const [contactos, setContatos] = useState<ContactFormData[]>([]);
  // const [openContact, setOpenContact] = useState(false);

  const {isEdit, setEdit, setOpenContact, open, setOpen, data2Edit, setData2Edit, setIndexEdit, indexEdit, setEditContact, setDeleteClient, setDeleteContact, setAlterStatus, alterStatus, handleStatusChange, clientId, setClientId} = useClientContext();
  const { createContact, updateContact, setAlterStatus2, alterStatus2, client, setClient} = useClients();
  
  const onContactSubmit = (clientId:number,dataContact:CreateClientContact) => {
    createContact(clientId, dataContact);
    setOpen(false);
  };

  const onContactEditSubmit = (dataContact: UpdateClientContact)=>{
    updateContact(dataContact);
    setOpen(false);
  };

  const createOrEditContact = (dataContact: any, clientId:number | undefined) => {
    if(clientId === undefined){
      onContactEditSubmit(dataContact);
    } else if(clientId){
      onContactSubmit(clientId, dataContact);
    }
  };

  const dataList = [...data];
  // console.log(dataList);

  return (
    <div className='m-4 rounded-md sm:border'>
      <Table>
        <TableHeader>
          <TableRow className= 'mx-2 bg-indigo-50'>
            {Constants.LISTA_COLUNAS_CLIENTES.map((coluna) => (
              <TableHead className='h-10' key={coluna}>{coluna}</TableHead>
            ))}
            <TableHead colSpan={2}>Ações</TableHead>
          </TableRow>
        </TableHeader>

        <TableBody>
          {data.map((cliente, index) =>(
            <Collapsible asChild key={index}>
              <>
                <TableRow className= 'mx-2'>
                  <CollapsibleTrigger asChild title='Mostrar Detalhes'>
                    <div className='px-2 flex items-center space-x-1 [&[data-state=open]>svg.chevron]:rotate-180'>
                      <ChevronDownIcon className="h-4 w-4 bg-indigo-50 hover:bg-indigo-200 rounded text-muted-foreground shrink-0 transition-transform duration-200 ease-in-out chevron" />
                      <TableCell>{cliente.nomefantasia}</TableCell>
                    </div> 
                  </CollapsibleTrigger>
                  <TableCell>{CustomInputMask.cpfCnpj(cliente.cpfOrCnpj)}</TableCell>
                  <TableCell>{cliente.razao}</TableCell>
                  <TableCell>{cliente.ramo}</TableCell>
                  <TableCell> 
                    <Badge className={cliente.status === 'Ativo' ? 'text-green-600 font-light bg-green-200 hover:bg-green-200' : 'text-red-600 font-light bg-red-200 hover:bg-red-200'}>{cliente.status}</Badge>
                  </TableCell>
                  <TableCell>
                    <div className='flex gap-2'>
                      <button title='Status' 
                        onClick={()=>{
                          setAlterStatus2(alterStatus2);
                          onClientStatusUpdate(index, cliente.id, cliente.status);  
                        }}>
                        {cliente.status === 'Ativo' ? <PowerOff className='bg-indigo-50 hover:bg-indigo-200 rounded-md p-1' /> : <Power className='bg-indigo-50 hover:bg-indigo-200 rounded-md p-1' /> }
                      </button>
                      <button title='Editar'>
                        <EditIcon size={26} onClick={()=>{
                          setOpen(true);
                          setEdit(true);
                          setData2Edit(data[index]);
                          setIndexEdit(index);
                        }} className='bg-green-600 hover:bg-green-800 rounded-md p-1'/>
                      </button>

                      <button title='Adicionar Contato' onClick={() => {
                        setIndexEdit(undefined);
                        setData2Edit(undefined);
                        setClientId(cliente.id);
                        // console.log(openContact);
                        setOpenContact(true);
                      }} >
                        <ContactRound  size={26}  className='bg-indigo-50 hover:bg-indigo-200 rounded-md p-1'/>
                        
                      </button>
                    </div>
                  </TableCell>
                </TableRow>
                <CollapsibleContent asChild>
                  <InnerTable dataContato={cliente}/>
                </CollapsibleContent>
              </>
            </Collapsible>
          ))}
        </TableBody>
      </Table>
      <ContactFormDialog onClientSubmit={createOrEditContact} clientId={clientId}/>
    </div>
  );
};

export default TableView;
